var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.9445C6.2185 8.9445 4.6425 9.4415 3.6635 10.1835C2.915 10.7505 2.5 11.466 2.5 12.222C2.5 12.9785 2.915 13.694 3.6635 14.261C4.6425 15.003 6.2185 15.5 8 15.5C9.7815 15.5 11.3575 15.003 12.3365 14.261C13.085 13.694 13.5 12.9785 13.5 12.222C13.5 11.466 13.085 10.7505 12.3365 10.1835C11.3575 9.4415 9.7815 8.9445 8 8.9445ZM8 0.5C6.0795 0.5 4.5 2.1695 4.5 4.25C4.5 6.3305 6.0795 8 8 8C9.9205 8 11.5 6.3305 11.5 4.25C11.5 2.1695 9.9205 0.5 8 0.5Z",
    fill: "#0047AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.30bb2d9c35b1443bfeebb67f35e31a87.svg";
export { ForwardRef as ReactComponent };